(function (){
    'use strict';

    angular
        .module('services')
        .service('ClientsPartnersService', ClientsPartnersService);

    ClientsPartnersService.$inject = ['$http', 'API_BASE'];

    function ClientsPartnersService($http, API_BASE) {

        var service = this;

        service.getAll        = getAll;

        function getAll() {
            return $http.get(API_BASE + '/partners/clients');
        }
    }
})();